module.exports = __webpack_public_path__ + "img/nostring-store-closed.974abce1.svg";